import { render, staticRenderFns } from "./ThgBatchDetailInformationDistributionCard.vue?vue&type=template&id=6b3da7b2&"
import script from "./ThgBatchDetailInformationDistributionCard.vue?vue&type=script&lang=ts&"
export * from "./ThgBatchDetailInformationDistributionCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VRow})
